// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * A qualitative measure of the background blur strength.
 * Note: the underlying blur implementation, and therefore the perceived strength, may change between different versions.
 */
type VideoFxBlurStrength = 'low' | 'medium' | 'high';

export default VideoFxBlurStrength;
